export default "__VITE_ASSET__9Sc1RNkL__"